import { createContext } from "react"

type VideoLanguageContext = {
  changedEntryPlayerId: string
  setEntryPlayerId: (id: string) => void
  changedEpisodeDocumentId: string
  setEpisodeDocumentId: (episodeDocumentId: string) => void
}

const VideoLanguageContext = createContext<VideoLanguageContext>({} as VideoLanguageContext)

export default VideoLanguageContext
